import { Box, Button } from '@material-ui/core';
import { OnboardingDetailsRole } from '@nemuru-eng/js-api-client';

import { useMerchantPosContext } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/_shared/contexts/MerchantPosContext';
import { ParticipantCard } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/components/ParticipantCards/ParticipantCard';
import { useMerchantPos } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Loan/PaymentIntent/Multilender/MerchantPos/MerchantPosForm/hooks/useMerchantPos';
import { Font } from '@/components/shared/components/Font';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';
import { useCustomTheme } from '@/hooks/useCustomTheme';
import { useScreen } from '@/hooks/useScreen';

const MAX_NUM_ONBOARDING_DETAILS_ALLOWED = 2;
export const ALLOWED_PARTICIPANTS = [OnboardingDetailsRole.CO_BORROWER, OnboardingDetailsRole.GUARANTOR];

export const ParticipantCards = () => {
  const { sm } = useScreen();
  const { borrowerOnboardingDetails } = useMerchantPosContext();
  const { setSelectedRole, deleteBorrowerOnboardingDetails } = useMerchantPos();
  const { palette, customBorderRadius } = useCustomTheme();

  const supportedOnboardingDetails = borrowerOnboardingDetails.filter((details) =>
    [OnboardingDetailsRole.BORROWER, OnboardingDetailsRole.CO_BORROWER].includes(details.role),
  );

  const roleToAdd =
    supportedOnboardingDetails.length < MAX_NUM_ONBOARDING_DETAILS_ALLOWED
      ? supportedOnboardingDetails[0].role === OnboardingDetailsRole.BORROWER
        ? OnboardingDetailsRole.CO_BORROWER
        : OnboardingDetailsRole.BORROWER
      : undefined;

  return (
    <div style={{ display: 'grid', gridTemplateColumns: sm ? '1fr 1fr' : '1fr', gap: 16 }}>
      {supportedOnboardingDetails.map((borrowerOnboardingDetail) => (
        <ParticipantCard
          key={borrowerOnboardingDetail.userDetails.documentId.documentNumber}
          borrowerOnboardingDetails={borrowerOnboardingDetail}
          setSelectedRole={setSelectedRole}
          onDeleteBorrowerOnboardingDetails={deleteBorrowerOnboardingDetails}
        />
      ))}
      {roleToAdd && (
        <Button
          onClick={() => setSelectedRole(roleToAdd)}
          style={{
            borderRadius: customBorderRadius.paper,
            height: '100%',
            width: '100%',
            border: `1px dashed ${palette.grey[200]}`,
            backgroundColor: palette.grey[50],
          }}
        >
          <Box height={'140px'} alignItems={'center'} display={'flex'}>
            <Box display={'flex'} flexDirection={'column'} gridGap={4}>
              <Icon size={26}>add_circle</Icon>
              <Font variant="subtitle2">
                <Text tId={`ADD_${roleToAdd}`} />
              </Font>
            </Box>
          </Box>
        </Button>
      )}
    </div>
  );
};
